import { Loading3QuartersOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { ReactComponent as Footprint } from '../../assets/images/footprint.svg';

const Loader = () => {
  return (
    <Spin
      indicator={
        <div className="relative min-w-[50px]">
          <Loading3QuartersOutlined
            className="text-bg5 text-[50px] opacity-50 [&>svg]:text-[50px]"
            spin
          />
          <div className="absolute left-[10px] top-[11px] [&>svg]:h-[26px] [&>svg]:w-[30px]">
            <Footprint />
          </div>
        </div>
      }
    />
  );
};

export default Loader;
